<nh-form [formGroup]="getForm()" [mode]="mode" (validate)="onValidate($event)">
  <section [formGroup]="getControl('data')">
    <div class="container start-page">
      <div>
        <h1 class="section-header">Medical Expense Information</h1>
        <hr />
        <nh-field
          [attr.aria-required]="true"
          id="medicalExpenseType"
          label="Incurred Medical Expense Type:"
          class="label-section"
          [mandatory]="true"
        >
          <select
            nh
            name="medicalExpenseType"
            aria-label="incurredMedicalExpenseType"
            (change)="onMedicalExpenseChange()"
            [items]="tables.MEDICALEXPENSETYPE"
            formControlName="medicalExpenseType"
            [required]="true"
          ></select>
        </nh-field>

        <nh-field
          [attr.aria-required]="true"
          id="payFrequency"
          label="Frequency:"
          class="label-section"
          [mandatory]="true"
        >
          <select
            nh
            name="payFrequency"
            aria-label="payFrequency"
            (change)="onPayFrequencyChange()"
            [required]="true"
            [items]="tables.INCEXPPAYFREQUENCY"
            formControlName="payFrequency"
          ></select>
        </nh-field>

        <nh-field
          [attr.aria-required]="true"
          id="dateOfService"
          label="Date of Service:"
          [mandatory]="true"
          class="label-section"
        >
          <nh-datepicker>
            <input
              type="text"
              name="dateOfService"
              aria-label="dateOfService"
              class="form-control"
              [required]="true"
              formControlName="dateOfService"
              bsDatepicker
              nh
              [minDate]="minimumDate"
              maxLength="10"
            />
          </nh-datepicker>
        </nh-field>
      </div>
      <div>
        <div class="d-flex align-items-center">
          <span class="text-danger ng-star-inserted" aria-hidden="true">*</span>
          <h2 class="section-header mb-0 ms-2">
            Upload a Medical Expense Document
          </h2>
          <span class="visually-hidden">{{ "required" | translate }}</span>
        </div>
        <hr />
        @if (displayLoading && !checkDocumentUploadError()) {
        <div class="row uploaded-documentname">
          <div class="col-8">
            <span class="pe-2 file-icon"
              ><img
                alt=""
                src="../../../../../../assets/images/⚛️ icons-document-attach-outline.svg"
            /></span>
            <span class="file-name" style="max-width: 440px">{{
              docName
            }}</span>
          </div>
          <div class="col-4">
            <div class="option-lables">
              <img
                src="../../../../../../assets/images/⚛️ File_Uploader_Loader.svg"
              />
            </div>
          </div>
        </div>
        } @for (doc of documents; track doc; let i = $index) {
        <div>
          <div class="row">
            <div class="col-md-12">
              @if (doc.error) {
              <div class="error-messages position-relative">
                <span class="form-text invalid-tooltip d-block">
                  <ng-container>{{ "REQUIRED" | translate }}</ng-container>
                </span>
              </div>
              }
            </div>
            @if (!isMobileView && !doc.file && i !== 0 && doc.show) {
            <div class="col-md-2 offset-md-4">
              <div
                class="d-flex align-items-center ps-1 pt-1 hover-red upload-btn-close"
              >
                <a tabindex="0" (click)="close(i)"
                  ><span class="pe-2">{{ "CLOSE" | translate }}</span
                  ><i class="fa fa-times-circle" aria-hidden="true"></i
                ></a>
              </div>
            </div>
            }
          </div>
          @if (doc.show) {
          <div class="row pt-2">
            <div class="col-md-12">
              <nh-file-upload
                (passFileData)="getFileDetails($event, i)"
                (fileUploadStarted)="getFileProgress($event)"
              >
              </nh-file-upload>
            </div>
          </div>
          }
          <div class="p-3">
            @if (doc.file?.name) {
            <div class="d-flex align-items-center uploaded-documentname">
              <div class="mb-4 d-flex align-items-center">
                <div class="file-icon me-2 d-flex align-items-center">
                  <img
                    alt=""
                    src="../../../../../../assets/images/⚛️ icons-document-attach-outline.svg"
                  />
                </div>
                <div
                  class="file-name me-auto d-flex align-items-center"
                  style="max-width: 440px"
                >
                  <span class="align-middle">{{ doc.file.name }}</span>
                </div>
              </div>
              <div class="hover-red option-lables d-flex align-items-center">
                <a
                  class="btn btn-link hover-red me-3 p-0 d-flex align-items-center"
                  tabindex="0"
                  (click)="viewPdf(i)"
                >
                  <span class="pe-2">{{ "View" | translate }}</span>
                  <svg
                    id="_icons_search-outline"
                    data-name="⚛️ icons/search-outline"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <defs>
                      <clipPath id="clip-path">
                        <rect
                          id="Background"
                          width="24"
                          height="24"
                          fill="#174a7c"
                        />
                      </clipPath>
                    </defs>
                    <g
                      id="Mask_Group_1"
                      data-name="Mask Group 1"
                      clip-path="url(#clip-path)"
                    >
                      <path
                        id="Combined_Shape"
                        data-name="Combined Shape"
                        d="M18.232,19.292l-.013-.012-4.927-4.927a8.122,8.122,0,1,1,1.061-1.061l4.927,4.927a.75.75,0,0,1-1.049,1.073ZM1.5,8.114A6.614,6.614,0,1,0,8.114,1.5,6.621,6.621,0,0,0,1.5,8.114Z"
                        transform="translate(2.25 2.25)"
                        fill="#174a7c"
                      />
                    </g>
                  </svg>
                </a>
                <a
                  class="btn btn-link hover-red p-0 d-flex align-items-center"
                  tabindex="0"
                  (click)="removeItem(i)"
                >
                  <span class="pe-2">{{ "REMOVE" | translate }}</span>
                  <nh-remove-svg></nh-remove-svg>
                </a>
              </div>
            </div>
            }
          </div>
        </div>
        }

        <div>
          <div class="row mt-3 col-md-12">
            <div class="ms-2">
              <button
                id="addAnother"
                (click)="addAnother()"
                class="btn btn-block btn-outline-secondary btn-add-another"
                [hidden]="!showAddAnother"
              >
                {{ "ADD_1" | translate }}
                <svg
                  id="_icons_add-circle-outline"
                  data-name="⚛️ icons/add-circle-outline"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    id="Combined_Shape"
                    data-name="Combined Shape"
                    d="M0,9.75A9.75,9.75,0,1,1,9.75,19.5,9.761,9.761,0,0,1,0,9.75Zm1.5,0A8.25,8.25,0,1,0,9.75,1.5,8.259,8.259,0,0,0,1.5,9.75ZM9,13.514V10.5H6A.75.75,0,0,1,5.985,9H9V6a.75.75,0,0,1,1.5-.015V9h3a.75.75,0,0,1,.014,1.5H10.5v3a.75.75,0,0,1-1.5.014Z"
                    transform="translate(2.25 2.25)"
                    fill="#174a7c"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</nh-form>